import { render, staticRenderFns } from "./ParametrizacaoOrcamentoPasso5.vue?vue&type=template&id=23924045&lang=html&"
import script from "./ParametrizacaoOrcamentoPasso5.vue?vue&type=script&lang=js&"
export * from "./ParametrizacaoOrcamentoPasso5.vue?vue&type=script&lang=js&"
import style0 from "./ParametrizacaoOrcamentoPasso5.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCardTitle,VCol,VContainer,VDataTable,VRow,VSwitch})
